import React from 'react';
import PropTypes from 'prop-types';
import * as S from './styled';

const OnlineIndicator = ({ status, size, pulse = false }) => (
  <S.OnlineIndicator
    status={status}
    size={size}
    pulse={pulse}
  />
);

OnlineIndicator.propTypes = {
  status: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
  pulse: PropTypes.bool,
};

export default OnlineIndicator;
